<template>
    <div class="wrap">
        <div class="banner">
            <el-row class="main padtb20">
                <el-col :span="4">
                    <img src="/static/img/logo.png" class="logo" alt />
                </el-col>
                <el-col :span="14" :offset="2">
                    <ul>
                        <li v-for="(item, index) in navList" :key="index" class="textright" @click="gonext(item.url, item.id)">
                            <router-link target="_blank" class="navfont titleHouer" :to="{ name: item.url, params: { type: item.id } }">{{ item.name }}</router-link>
                        </li>
                    </ul>
                </el-col>
                <el-col :span="2" :offset="2" class="textcenter">
                    <div class="loginBtn" @click="login">登录/注册</div>
                </el-col>
            </el-row>
        </div>
        <div class="main martf60">
            <el-row class="flex">
                <el-col :span="16">
                    <div class="top1">找办公室</div>
                    <el-row>
                        <el-col :span="12">
                            <el-input placeholder="输入区域/商圈/楼盘名称" v-model="search" @input="searchList" clearable>
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                            <div class="search-content" v-if="isShowTip">
                                <div class="search-content-item" v-for="(item, index) in resultList" :key="index" @click="searchDetail(item)">
                                    <el-row>
                                        <el-col :span="5">
                                            <span class="typeName">{{ item.typeName }}</span>
                                        </el-col>
                                        <el-col :span="10">
                                            <span>{{ item.name }}</span>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" plain class="search" @click="searchFuntop">搜索</el-button>
                        </el-col>
                    </el-row>
                    <el-row class="mart10">
                        <el-col :span="2" class="font14 font600">区域</el-col>
                        <el-col :span="18">
                            <el-link :underline="false" v-for="(item, index) in cityregion" :key="index" class=" titleHouer padlf8 marr15 font12 line28" @click.native="goDetail(item.id, 'qy')">{{ item.name }}</el-link>
                        </el-col>
                        <!-- <el-col :span="2" class="font14 textcenter">
                            <router-link :to="{ name: 'OfficebuildList' }">更多>></router-link>
                        </el-col> -->
                    </el-row>
                    <!-- <el-row class="mart10">
                        <el-col :span="2" class="font14 font600">装修</el-col>
                        <el-col :span="18">
                            <el-link :underline="false" v-for="(item, index) in decorationList" :key="index" class=" titleHouer padlf8 marr15 font12 line28" @click.native="goDetail(item.val, 'zx')">{{ item.name }}</el-link>
                        </el-col>
                    </el-row> -->
                    <el-row class="mart10">
                        <el-col :span="2" class="font14 font600">面积</el-col>
                        <el-col :span="18">
                            <el-link :underline="false" v-for="(item, index) in areaList" :key="index" class=" titleHouer padlf8 marr15 font12 line28" @click.native="goDetail(item.val, 'mj')">{{ item.name }}</el-link>
                        </el-col>

                        <!-- <el-col :span="2" class="font14 textcenter">
                            <router-link :to="{ name: 'OfficebuildList' }" class="col333">更多>></router-link>
                        </el-col> -->
                    </el-row>
                </el-col>
                <el-col :span="8">
                    <div class="top1 padb0 mart20 titleHouer" @click="searchphone">委托寻找房源>></div>
                    <div class="font600 font14">委托城市好房帮您寻找房源</div>
                    <!-- <el-row>
                        <el-col :span="12">
                            <el-input placeholder="输入手机号" v-model="phone" clearable>
                                <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                            </el-input>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="info" class="wtBtn" plain @click="searchphone">委托</el-button>
                        </el-col>
                    </el-row> -->
                    <div class="top1 padb0 mart20 titleHouer" @click="entrustcs">业主投放房源>></div>
                    <div class="font600 font14">委托城市好房帮您出租，海量客源，快速成交</div>
                </el-col>
            </el-row>
        </div>
        <div class="main mart60">
            <div>
                <el-row>
                    <el-col :span="12" class="textleft title">热门商圈</el-col>
                    <el-col :span="12" class="textright colred font600 line50">
                        <router-link class="colred font600" to="/OfficebuildList?type=3">更多好房</router-link>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8" class="textleft relative" v-for="(item, index) in hotBusinessList" :key="index" @click.native="toNext(1,item.id,item.districtCode)">
                        <img :src="item.imageUrl" class="listimg" :alt="item.name" />
                        <div class="shadow">{{ item.name }}</div>
                    </el-col>
                </el-row>
            </div>
            <!-- <div class="mart30">
                <el-row>
                    <el-col :span="12" class="textleft title">新房</el-col>
                    <el-col :span="12" class="textright line50">
                        <router-link to="/newhouseList?type=1" class="colred font600">更多新房</router-link>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col v-for="(item, index) in hotProjectList" :key="index" :span="6" class="textleft relative col666" @click.native="toNext(2,item.id)">
                        <img :src="item.imageUrl" class="listimg height200" alt />
                        <el-row class="wid95 col333">
                            <el-col :span="24" class="font16 font600 line30">{{  item.name }}</el-col>
                            <el-col :span="12" class="font14">{{ commonfun.returnRegion(item.districtCode) }} -
                                {{ commonfun.returnBussileList(item.business) }}</el-col>
                            <el-col :span="12" class="textright font14">单价：{{ item.price }}元/m² 起</el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div> -->
            <div class="mart30">
                <el-row>
                    <el-col :span="12" class="textleft title">精选写字楼</el-col>
                    <el-col :span="12" class="textright colred font600 line50">
                        <router-link to="/OfficebuildList?type=3" class="colred font600">更多写字楼</router-link>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col v-for="(item, index) in officeList" :key="index" :span="6" class="textleft relative" @click.native="toNext(3,item.id)">

                        <img :src="item.imageUrl" class="listimg height200" alt />
                        <el-row class="wid95 col333">
                            <el-col :span="24" class="font16 font600 line30">{{
                  item.name
                }}</el-col>
                            <!-- <el-col :span="8" class="textright colred line30 font600"
                  >{{ item.sellPrices }}万</el-col
                > -->
                            <el-col :span="16" class="font14 s-line-text">{{ commonfun.returnRegion(item.districtCode) }} -
                                {{ commonfun.returnBussileList(item.business) }}
                                {{ item.areas }}-{{ item.areae }}m²</el-col>
                            <el-col :span="8" class="textright font14 colorred">{{ item.leasePrices }}元/m² 起</el-col>
                        </el-row>

                    </el-col>
                    <!-- <el-col :span="6" class="textcenter relative">
            <img src="/static/img/bf1.png" class="listimg height200" alt />
          </el-col>
          <el-col :span="6" class="textcenter relative">
            <img src="/static/img/bf1.png" class="listimg height200" alt />
          </el-col>
          <el-col :span="6" class="textright relative">
            <img src="/static/img/bf1.png" class="listimg height200" alt />
          </el-col>-->
                </el-row>
            </div>
            <div class="mart30">
                <el-row>
                    <el-col :span="12" class="textleft title">热门房源</el-col>
                </el-row>
                <el-row>
                    <el-col :span="20" v-if="officeBuildList.length > 0">
                        <el-row class="padtb20 borderb pointer" v-for="(item, index) in officeBuildList" :key="index" @click.native="toNext(4,item.id)">
                            <el-col :span="6">
                                <div class="listmsg">
                                    <el-image v-if="item.imageUrl" :src="item.imageUrl" alt />
                                    <el-image v-else src="http://img.sccshf.com/defaultimage1.png" />
                                </div>
                            </el-col>
                            <el-col :span="12" :offset="1" class="padl5">
                                <div class="font20 col333 font600 line50 titleHouer">
                                    {{ item.title }}
                                </div>
                                <div class="font16 col666 line30">
                                    {{ item.area }}m² /
                                    {{
                    commonfun.getDictLabel("dictRenovation", item.renovation)
                  }}
                                    / {{ commonfun.returnRegion(item.districtCode) }} -
                                    {{ commonfun.returnBussileList(item.business) }}-{{
                    item.address
                  }}
                                </div>
                                <div class="font16 col666 line30">
                                    {{ item.dictName }} / {{ item.olevel }}写字楼
                                </div>
                                <div class="font16 col666 line30" v-if="item.houseLabel != null">
                                    <div :class="'disinline bg' + inq" v-for="(it, inq) in item.houseLabel" :key="inq">
                                        {{ commonfun.getDictLabel("houseLabel", it) }}
                                    </div>
                                </div>
                            </el-col>
                            <el-col :span="5" class="textright">
                                <!-- <div class="colfff line50">0</div> -->
                                <div class="colred mart50">
                                    <span class="font24 font600">{{ item.prices }}</span>
                                    <span class="font16">元/月</span>
                                </div>
                                <div class="font16 col999 line30">
                                    单价：{{ item.price }}元/m²/月
                                </div>
                                <div class="font16 line24">
                                    <div class="disinline imghear"></div>
                                    <template>
                                        <el-popover
                                            placement="top-start"
                                            width="200"
                                            trigger="hover"
                                        >
                                            <div class="qrcode-container">
                                                <p class="popup-title">微信扫码咨询</p>
                                                <el-image 
                                                    style="width: 150px; height: 150px" 
                                                    :src="item.wxPhoto"
                                                ></el-image>
                                            </div>
                                            <el-button class="wx" slot="reference">微信咨询</el-button>
                                        </el-popover>
                                    </template>

                                    <template>
                                        <el-popover
                                            placement="top-start"
                                            width="250"
                                            trigger="hover"
                                        >
                                            <div class="phone-container">
                                                <p class="popup-title">手机拨打电话咨询</p>
                                                <p class="phone-number">
                                                    <i class="el-icon-phone"></i>
                                                    {{ item.userName }} / {{ item.mobile }}
                                                </p>
                                            </div>
                                            <el-button class="tel" slot="reference">电话咨询</el-button>
                                        </el-popover>
                                    </template>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row></el-row>
                    </el-col>
                    <el-col :span="19" v-else class="line50 textcenter">暂无数据</el-col>
                </el-row>
            </div>
        </div>
        <footers></footers>
        <regionDialog :dialogVisible="logindialogVisible" @close="close"></regionDialog>
    </div>
</template>

<script>
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?9e0c3bb7a21ac1390b0fe0760240a0b0";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
import footers from "../components/footer";
import regionDialog from "../components/region";
import entrust from "../components/entrust";
export default {
    data() {
        return {
            tenantCode: this.$store.state.tenantCode,
            secondHouseList: [],
            hotProjectList: [],
            officeList: [], //写字楼
            shopsList: [], //优质好铺
            hotBusinessList: [], //热门商圈
            officeBuildList: [],
            isShowTip: false,
            searchVal: "",
            searchId: "",
            searchType: "",
            resultList: [],
            navList: [
                { name: "首页", url: "", id: "0" },

                // { name: "二手房", url: "SecondhandRoomDetail",id:'2' },
                { name: "写字楼租赁", url: "OfficebuildList", id: "1" },
                { name: "写字楼买卖", url: "OfficeBuildingListSale", id: "2" },
                {
                    name: "写字楼楼盘",
                    url: "OfficeBuildingListRealEstate",
                    id: "3",
                },
                // { name: "新房", url: "newhouseList", id: "5" },
                { name: "委托", url: "entrustzf", id: "6" },
                { name: "发布", url: "entrustcz", id: "7" },
                // { name: "热门资讯", url: "entrust", id: "7" },
            ],
            decorationList: [
                { val: null, name: "不限" },
                { val: "豪华装修", name: "豪华装修" },
                { val: "精装修", name: "精装修" },
                { val: "简单装修", name: "简单装修" },
                { val: "毛胚房", name: "毛胚房" },
            ],
            logindialogVisible: false,
            cityregion: [],
            search: "",
            area: [0, 0],
            marks: {
                0: "0",
                10: "100m²",
                20: "300m²",
                30: "500m²",
                40: "1000m²",
                50: "1000m²+",
            },
            phone: "",
            queryParam: {
                page: 1, //	当前页码
                limit: 20, //每页显示记录数
                orderField: "", //排序字段
                order: "", //排序方式，可选值(asc、desc)
                tenant_code: this.$store.state.tenantCode, //城市编码
                districtCode: null, //行政区
                business: null, //所属商圈
                metroId: null, //地铁线路
                stationId: null, //地铁站点
                type: null, //写字楼类型
                renovation: null, //装修类型 @dictRenovation
                prices: null, //最低单价
                pricee: null, //最高单价
                pricess: null, //最低总价
                pricese: null, //最低总价
                areas: null, //最低面积
                areae: null, //最高面积
                search: "", //搜索字段
            },
            areaList: [
                { val: "-", name: "不限" },
                { val: "0-100", name: "<100m²" },
                { val: "100-300", name: "100-300m²" },
                { val: "300-500", name: "300-500m²" },
                { val: "500-1000", name: "500-1000m²" },
                { val: "1000-100000", name: ">1000m²" },
            ],
        };
    },
    components: {
        footers,
        regionDialog,
        entrust,
    },

    async beforeCreate() {
        // 确保字典数据最先加载
        await this.$get(this.$api.common.allDictType)
            .then((res) => {
                if (res.code == 0) {
                    this.$store.commit("updateAllDictType", res.data);
                }
            })
            .catch((err) => {
                console.log('获取字典数据失败:', err);
            });
    },

    async created() {
        try {
            // 并行请求数据
            await Promise.all([
                this.getHotProjectList(),
                this.getSecondHouseList(), 
                this.getofficeList(),
                this.getshopsList(),
                this.getcityregion(),
                this.getleaseList(),
                this.gethotBusinessList()
            ]);
        } catch (error) {
            console.error('数据加载失败:', error);
        }
    },
    mounted() {

    },
    methods: {
        // 城市行政区
        async getcityregion() {
            try {
                const tenantCode = { tenantCode: this.tenantCode };
                const res = await this.$get(this.$api.common.cityregion, tenantCode);
                
                if (res.code == 0) {
                    this.cityregion = JSON.parse(JSON.stringify(res.data));
                    this.cityregion.length = 5;
                    this.$store.commit("getRegion", res.data);
                }
            } catch (err) {
                console.error('获取城市行政区失败:', err);
            }
        },
        // 导航点击事件
        gonext(url, id) {
            // 已经有router-link处理跳转，此方法为空即可
            console.log('导航点击:', url, id);
        },
        searchFuntop() {
            // console.log('tag', this.search)
            this.$router.push({
                name: "OfficebuildList",
                params: { search: this.search },
            });
        },
        changeArea(val) {
            if (val[1] - val[0] !== 10) {
                val[0] = val[1] - 10;
            }
            this.area = val;
            let areas = [];
            for (const it in this.marks) {
                if (it == val[0]) {
                    areas[0] = parseInt(this.marks[it]);
                }
                if (it == val[1]) {
                    areas[1] = parseInt(this.marks[it]);
                }
            }
            this.$router.push({
                name: "OfficebuildList",
                params: { area: areas },
            });
            console.log("tag", val);
        },
        goDetail(val, tab) {
            console.log("tag", val);
            if (tab === "qy") {
                this.$router.push({
                    name: "OfficebuildList",
                    params: { qy: val },
                });
            } else if (tab === "mj") {
                this.area = val;
                this.$router.push({
                    name: "OfficebuildList",
                    params: { area: val },
                });
            } else if (tab === "zx") {
                this.$router.push({
                    name: "OfficebuildList",
                    params: { zx: val },
                });
            }
        },
        searchphone() {
            this.$router.push({
                name: "entrustcz",
                params: { phone: this.phone },
            });
        },
        entrustcs() {
            this.$router.push({
                name: "entrustcs",
                params: { phone: this.phone },
            });
        },
        // 获取热门楼盘
        async getHotProjectList() {
            try {
                const tenantCode = { tenantCode: this.tenantCode };
                const res = await this.$get(this.$api.home.hotProjectList, tenantCode);
                
                if (res.code == 0) {
                    this.hotProjectList = res.data;
                }
            } catch (err) {
                console.error('获取热门楼盘失败:', err);
            }
        },
        // 热门商圈
        async gethotBusinessList() {
            try {
                const tenantCode = { tenantCode: this.tenantCode };
                const res = await this.$get(this.$api.home.hotBusiness, tenantCode);
                
                if (res.code == 0) {
                    this.hotBusinessList = res.data;
                }
            } catch (err) {
                console.error('获取热门商圈失败:', err);
            }
        },
        // 获取品质二手房
        async getSecondHouseList() {
            // console.log(this.$api.home.secondHouseList);
            var tenantCode = { tenantCode: this.tenantCode };
            this.$get(this.$api.home.secondHouseList, tenantCode)
                .then((res) => {
                    console.log("品质二手房", res);
                    if (res.code == 0) {
                        this.secondHouseList = res.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 获取写字楼
        async getofficeList() {
            try {
                const tenantCode = { tenantCode: this.tenantCode };
                const res = await this.$get(this.$api.home.officeList, tenantCode);
                
                if (res.code == 0) {
                    this.officeList = res.data;
                }
            } catch (err) {
                console.error('获取写字楼失败:', err);
            }
        },
        // 获取优质好铺
        async getshopsList() {
            // console.log(this.$api.home.secondHouseList);
            var tenantCode = { tenantCode: this.tenantCode };
            this.$get(this.$api.home.shopsList, tenantCode)
                .then((res) => {
                    console.log("优质好铺", res);
                    if (res.code == 0) {
                        this.shopsList = res.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getAllDictType() {
            this.$get(this.$api.common.allDictType)
                .then((res) => {
                    console.log("字典数据", res);
                    if (res.code == 0) {
                        this.$store.commit("updateAllDictType", res.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 出租
        async getleaseList() {
            try {
                const tenantCode = { tenantCode: this.tenantCode };
                this.officeBuildList = [];
                const res = await this.$get(this.$api.home.recommendHouseList, tenantCode);
                
                if (res.code == 0) {
                    res.data.forEach((item, index) => {
                        item.houseLabel = item.houseLabel
                            ? item.houseLabel.split(",")
                            : item.houseLabel;
                    });

                    this.officeBuildList = res.data;
                }
            } catch (err) {
                console.error('获取出租列表数据失败:', err);
            }
        },
        toNext(type, id,param) {
            let routeUrl;
            console.log("type:" + type, "id:" + id);
            if (type == 1) {
                // 热门商圈跳转
                routeUrl = this.$router.resolve({
                    path: "/OfficebuildList",
                    query: {
                        districtCode: param,  // 区域id
                        business: id,      // 商圈id 
                    },
                });
            } else if (type == 2) {
                routeUrl = this.$router.resolve({
                    path: "/newhouseDetail",
                    query: {
                        houseid: id,
                    },
                });
            } else if (type == 3) {
                routeUrl = this.$router.resolve({
                    path: "/builsDetail",
                    query: {
                        houseid: id,
                    },
                });
            } else if (type == 4) {
                routeUrl = this.$router.resolve({
                    path: "/officeLeaseDetail",
                    query: {
                        houseid: id,
                    },
                });
            }
            console.log('解析后的 URL:', routeUrl.href);
            window.open(routeUrl.href, "_blank");
        },
        login() {
            this.logindialogVisible = true;
        },
        close(val) {
            this.logindialogVisible = val;
        },
        searchDetail(val) {
            this.isShowTip = false;
            this.search = val.name;
            this.searchId = val.id;
            this.searchType = val.type;
        },
        searchList() {
            this.isShowTip = true;
            console.log("城市行政区");
            if (this.search === "") {
                this.isShowTip = false;
                return;
            }
            if (this.search && this.search.length > 0) {
                return new Promise((resolve, reject) => {
                    this.$get(this.$api.common.search, { search: this.search })
                        .then((res) => {
                            // console.log("城市行政区", res);
                            if (res.code == 0) {
                                this.resultList = res.data;
                            }
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            }
        },
    },
};
</script>

<style   lang="scss" scoped>
.main {
    width: 75rem;
    margin: auto;
    position: relative;
}
.banner {
    width: 100%;
    height: 600px;
    background: url(/static/img/axsmHK4x.jpg) no-repeat;
    background-position: center center;
    background-size: cover;
    position: relative;
}
.navfont {
    font-size: 1rem;
    color: #fff;
    font-weight: 600;
    line-height: 2.5rem;
}
.logo {
    width: 9.25rem;
    height: 2.5rem;
}
.loginBtn {
    width: 90%;
    margin: auto;
    padding: 5px 3px;
    border: 1px solid #fff;
    background: #00000014;
    border-radius: 0.875rem;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;
    color: #fff;
    /* display: inline-block; */
}
.height200 {
    height: 12.5rem !important;
}
.title {
    font-size: 1.875rem;
    line-height: 3.125rem;
    color: red;
    font-weight: 600;
}
.listimg {
    width: 95%;
    height: 16.875rem;
}
.shadow {
    width: 95%;
    height: 16.875rem;
    position: absolute;
    top: 0px;
    text-align: center;
    line-height: 16.875rem;
    background: #00000055;
    color: #fff;
    font-size: 1.25rem;
    font-weight: 600;
}
.left5 {
    left: 2.5%;
}
.right0 {
    right: 0%;
}
.mart60 {
    margin-top: 3.75rem;
}
.martf60 {
    margin-top: -2rem;
}
.flex {
    /* display: flex; */
    background: #fff;
    border-radius: 0.625rem;
    padding: 1.25rem;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
}
.wtBtn,
.search {
    width: 100%;
    height: 40px;
    background: #da251d !important;
    border: 0px !important;
    color: #fff !important ;
}
.wtBtn {
    background: #5e5e5e !important;
}
.top1 {
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5rem;
    padding-bottom: 1.125rem;
    color: #333;
}
.padb0 {
    padding-bottom: 0.625rem;
}
.mart10 {
    margin-top: 0.625rem;
}
.colorred {
    color: #ec2549;
}
.bg1,
.bg4 {
    color: #91bebe;
    background: #cee9e9;
    padding: 0px 3px;
    margin: 0px 4px;
    border-radius: 3px;
    line-height: 24px;
    font-size: 12px;
}
.bg2,
.bg5 {
    background: #f2e9b9;
    color: #d1c06b;
    padding: 0px 3px;
    margin: 0px 4px;
    border-radius: 3px;
    line-height: 24px;
    font-size: 12px;
}
.bg3,
.bg0 {
    background: #c9e1ff;
    color: #80ade4;
    padding: 0px 3px;
    margin: 0px 4px;
    border-radius: 3px;
    line-height: 24px;
    font-size: 12px;
}
ul li {
    float: left;
    margin-right: 2.25rem;
}
.search-content {
    width: 50%;
    cursor: pointer;
    z-index: 999;
    position: absolute;
    background: #fff;
    border-width: 1px;
    border-color: #eae0e0;
    border-style: solid;
}
.search-content-item {
    margin: 0.25rem;
}
.typeName {
    color: #ffb294;
    background-color: #ffe8dc;
    margin: 1rem;
}
.qrcode-container,
.phone-container {
    text-align: center;
    padding: 10px;
}

.popup-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    font-weight: 500;
}

.phone-number {
    font-size: 16px;
    color: #DA251D;
    font-weight: 600;
    
    .el-icon-phone {
        margin-right: 5px;
    }
}

.wx,
.tel {
    margin: 0 5px;
    padding: 5px 15px;
    border-radius: 4px;
    font-size: 14px;
}

.wx {
    background-color: #67C23A;
    border-color: #67C23A;
    color: #fff;
    
    &:hover {
        background-color: #85ce61;
        border-color: #85ce61;
    }
}

.tel {
    background-color: #DA251D;
    border-color: #DA251D;
    color: #fff;
    
    &:hover {
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
}

// 添加弹出框样式
.el-popover {
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue